// extracted by mini-css-extract-plugin
export default {"root":"loadingIcon_root__5tWRH","spin":"loadingIcon_spin__4t1IT"};